import React from 'react';
import {
  DropdownMenuGroup,
  DropdownMenuGroupProps
} from '../DropdownMenu/DropdownMenuGroup';

export interface SelectOptionGroupProps extends DropdownMenuGroupProps {}

export function SelectOptionGroup(props: SelectOptionGroupProps) {
  return <DropdownMenuGroup {...props} />;
}
